export default "__VITE_ASSET__D8BwTyYA__"